module.exports = __webpack_public_path__ + "assets/d42f710806f8542b931ab934185f1c62.png";